/**
 * Generates a booking link for a salon's business location.
 *
 * The customer booking platform identifies the location via the
 * `businessLocationId` query param. In this codebase that value is the salon
 * UUID (`businessInfo.id`) — the same value historically passed as `salonId`.
 *
 * @param businessLocationId - The business location UUID (salon `businessInfo.id`)
 * @returns The booking link URL, or empty string if the id is not provided
 */
export function generateBookingLink(
  businessLocationId: string | null | undefined,
): string {
  return customerLink("/book", businessLocationId);
}

/**
 * Generates the walk-in waitlist (kiosk check-in) link for a business
 * location: the customer booking platform's `/walk-in` route, keyed by the
 * same `businessLocationId` query param as {@link generateBookingLink}.
 *
 * @param businessLocationId - The business location UUID (salon `businessInfo.id`)
 * @returns The walk-in link URL, or empty string if the id is not provided
 */
export function generateWalkInLink(
  businessLocationId: string | null | undefined,
): string {
  return customerLink("/walk-in", businessLocationId);
}

/** `{REACT_APP_BASE_BOOKING_URI}{path}?businessLocationId={id}` ("" without an id). */
function customerLink(
  path: string,
  businessLocationId: string | null | undefined,
): string {
  if (!businessLocationId) {
    return "";
  }

  const baseUri = process.env.REACT_APP_BASE_BOOKING_URI || "";
  return `${baseUri}${path}?businessLocationId=${businessLocationId}`;
}
